import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"spellcheck":"true","type":"text","maxlength":"10","value":_vm.bag,"error":_vm.error,"error-messages":_vm.message},nativeOn:{"change":function($event){return _vm.updateBag.apply(null, arguments)}},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('span',{staticClass:"pt-1"},[_vm._v(" "+_vm._s(_vm.survey.job_number)+"."+_vm._s(_vm.building.phase ? _vm.building.phase + "." : ""))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }